import { Sparkles } from 'lucide-react';

export function SponsoredBadge({ variant = 'default' }) {
  if (variant === 'minimal') {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
        <Sparkles className="w-3 h-3" />
        <span>Sponsored</span>
      </span>
    );
  }

  return (
    <div className="inline-flex items-center gap-2 border border-border px-3 py-1.5 bg-background">
      <Sparkles className="w-3.5 h-3.5" />
      <span className="text-xs uppercase tracking-widest">Sponsored</span>
    </div>
  );
}

